import { colors, spacing, styled } from "../../../../../../../stitches.config";

export const TabGroupWrapper = styled("div", {
  borderBottom: colors.borderUi,
  marginBottom: "16px",
});

export const FormSection = styled("section", {
  marginTop: spacing.s,
});

export const FormSectionTitleWrapper = styled("div", {
  marginBottom: spacing.m,
});

export const FieldWrapper = styled("div", {
  marginTop: spacing.s,
  marginBottom: spacing.m,
});
